import { SourceToDest } from '@rgba-image/common'

export const copy: SourceToDest = ( 
  source: ImageData, dest: ImageData, 
  sx = 0, sy = 0, sw = source.width - sx, sh = source.height - sy, 
  dx = 0, dy = 0 
) => {
  sx = sx | 0
  sy = sy | 0
  sw = sw | 0
  sh = sh | 0
  dx = dx | 0
  dy = dy | 0

  if( sw <= 0 || sh <= 0 ) return

  const sourceData = new Uint32Array( source.data.buffer )
  const destData = new Uint32Array( dest.data.buffer )

  for ( let y = 0; y < sh; y++ ) {
    const sourceY = sy + y

    if( sourceY < 0 || sourceY >= source.height ) continue

    const destY = dy + y

    if( destY < 0 || destY >= dest.height ) continue

    for ( let x = 0; x < sw; x++ ) {
      const sourceX = sx + x

      if( sourceX < 0 || sourceX >= source.width ) continue

      const destX = dx + x

      if ( destX < 0 || destX >= dest.width ) continue

      const sourceIndex = sourceY * source.width + sourceX
      const destIndex = destY * dest.width + destX

      destData[ destIndex ] = sourceData[ sourceIndex ]
    }
  }
}
